import {CREATE_ALLOWED_ROUTES} from '../actions/actionTypes';
import { createReducer } from './reducerUtilities';

const initialState = {
};


// Slice reducer
export const generalReducer = createReducer(initialState, {
  [CREATE_ALLOWED_ROUTES] : createAllowedRoutes,
});


// -----------------------------------------------------------------------
// CREATE ALLOWED ROUTES
// -----------------------------------------------------------------------

// Case reducer
function createAllowedRoutes(state, action) {
  return {...state, routes: action.payload.allowedRoutesList} 
}


// -----------------------------------------------------------------------
// 
// -----------------------------------------------------------------------



// WEBPACK FOOTER //
// ./src/reducers/generalReducer.js